import { Box, Grid, Theme, Typography } from "@mui/material";
import { ViewProfileProps } from "../types";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import React from "react";
import { SubHeading } from "../../investors/components";
import { formatShortDate } from "../../../utils/date";
import { checkAddressField, getUniqueIdentityText, isMinor } from "../../../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { idProofLabelsMasters } from "../../../utils/constant";

export default function NomineeDetails({ overviewData }: { overviewData: Partial<ViewProfileProps> }): JSX.Element {
    const { nominees, nomineesSOA } = overviewData;
    const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'customColors.infoCard',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box >
                    <Grid container >
                        <Typography variant='h2' sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[500], mb: '9px' })}>
                            Nominee Details
                        </Typography>
                        <Grid
                            xs={12}
                            sm={12}
                            sx={{
                                fontSize: 16,
                                fontWeight: 600,
                                color: 'text.primary',
                                my: 1.5,
                            }}>

                            <KeyValue
                                title={`Display Nominees in SOA`}
                                description={nomineesSOA ? 'Yes' : 'No'}
                            />
                        </Grid>
                        {nominees?.length === 0 ? (
                            <Grid
                                xs={12}
                                sm={12}
                                sx={{
                                    fontSize: 16,
                                    fontWeight: 600,
                                    color: 'text.primary',
                                    textAlign: 'center',
                                    my: 1.5,
                                }}>
                                No Nominees Added
                            </Grid>
                        ) : (
                            nominees?.map((nominee, index: number) => {
                                const title = [
                                    'First Nominee',
                                    'Second Nominee',
                                    'Third Nominee',
                                ][index];
                                return (
                                    <React.Fragment key={nominee.id}>
                                        <SubHeading sx={{ color: 'text.primary', letterSpacing: "0.02px" }}>
                                            {title} Details
                                        </SubHeading>

                                        <Grid
                                            item
                                            container

                                            rowSpacing={3}
                                            columnSpacing={5.5}
                                            direction="row"

                                        >
                                            <KeyValue
                                                title={`Nominee Name ${index + 1}`}
                                                description={nominee.nomineeName}
                                            />
                                            <KeyValue
                                                title={'Nominee RelationShip'}
                                                description={nominee.nomineeRelationship}
                                            />
                                            <KeyValue
                                                title={'Date Of Birth'}
                                                description={formatShortDate(nominee.dateOfBirth)}
                                            />
                                            <KeyValue
                                                title={'Nominee Percentage'}
                                                description={nominee.nomineePercentage}
                                            />
                                            {/* <KeyValue title={`Nominee ${getUniqueIdentityText(company)?.pan}`} description={nominee.nomineePan} /> */}
                                            {nominee.dateOfBirth && isMinor(nominee.dateOfBirth) && (
                                                <>
                                                    <KeyValue title={'Guardian Name'} description={nominee.guardianName} />
                                                    <KeyValue
                                                        title={'Guardian Pan'}
                                                        description={nominee.nomineeGuardianPan}
                                                    />
                                                </>
                                            )}
                                            <Grid item xs={12}>
                                                <SubHeading
                                                    sx={{
                                                        letterSpacing: '0.02px',
                                                    }}>
                                                    Address & Contact Details of {title}
                                                </SubHeading>
                                            </Grid>
                                            <KeyValue
                                                title={'Nominee ID Proof Type'}
                                                description={nominee.idProofType ?? '-'}
                                            />
                                            <KeyValue
                                                title={`Nominee ${idProofLabelsMasters[nominee.idProofType as string] ?? 'ID Proof Value'}`}
                                                description={nominee.idProofValue ?? '-'}
                                            />
                                            <KeyValue
                                                title={'Nominee Mobile'}
                                                description={
                                                    nominee.countryCode
                                                        ? nominee.countryCode + '-' + (nominee.mobile ?? "-")
                                                        : (nominee.mobile ?? "-")
                                                }
                                            />
                                            <KeyValue
                                                title={'Nominee Email'}
                                                description={nominee.email ?? '-'}
                                            />
                                            <KeyValue
                                                title={`Nominee Address`}
                                                description={nominee.address1 ? `${checkAddressField(
                                                    nominee?.address1
                                                )}${checkAddressField(nominee?.address2)}
                                                                    ${checkAddressField(nominee?.address3)}
                                                                    ${checkAddressField(nominee?.city)}${checkAddressField(
                                                    nominee?.state
                                                )}${checkAddressField(nominee?.country)}${nominee?.pincode ?? ''}` : '-'}
                                                sx={{
                                                    textTransform: 'capitalize',
                                                }}
                                            />
                                        </Grid>

                                    </React.Fragment>
                                );
                            })
                        )}
                    </Grid>
                </Box>
            </Box >
        </>
    )
}